import {
    PersonData,
    Profession,
    Pix,
} from '../../models/agents/person-data';
import { BankData } from '../../models/agents/bank-data';
import { RegistrationHistory } from '../../models/agents/registration-history';
import { SuitabilityScore } from '../../models/agents/suitability-score';
import { Address } from '../../models/agents/address';
import { Files } from '../../models/agents/files';
import { Authorizations, Ppe } from '../../models/agents/authorizations';
import { Question } from '../../models/suitability/question';
import { Invitation } from '../../models/agents/invitation.ts';
import { FinancialStatement } from '../../models/agents/financial-statement';
import { Suitability } from '../../models/suitability/suitability';
import { PersonType } from '../../models/enums/person-type.enum';
import { AgentRegister } from '../../models/agents/agent-register';
import { ContractData } from '../../models/agents/contract-data';
import { Beneficiary } from '../../models/agents/beneficiary';

export class RegisterInvitationCode {
    readonly type = 'REGISTER_INVITATION_CODE';
    constructor(public invitationIdentify: string) {}
}

export class CleanPerson {
    readonly type = 'CLEAN_PERSON';
    constructor(public payload: PersonData) {}
}

export class AddAgent {
    readonly type = 'ADD_AGENT';
    constructor(public payload: AgentRegister) {}
}

export class InitPersonFromServer {
    readonly type = 'INIT_PERSON_FROM_SERVER';
    constructor(
        public person: PersonData,
        public serverIdentify: string,
        public registrationHistory: RegistrationHistory[],
        public invitation: Invitation
    ) {}
}

export class PersonConfirmRegistration {
    readonly type = 'PERSON_CONFIRM_REGISTRATION';
    constructor(public confirmed: boolean) {}
}

export class AddPersonRegistrationHistory {
    readonly type = 'UPDATE_REGISTRATION_HISTORY_ON_SERVER';
    constructor(public history: RegistrationHistory) {}
}

export class AddPerson {
    readonly type = 'ADD_PERSON';
    constructor(public person: PersonData, public personType: PersonType) {}
}

export class AddPersonOnServer {
    readonly type = 'UPDATE_PERSON_ON_SERVER';
    constructor(public person: PersonData) {}
}

export class UpdatePerson {
    readonly type = 'UPDATE_PERSON';
    constructor(public person: PersonData) {}
}

export class AddPersonAddress {
    readonly type = 'ADD_PERSON_ADDRESS';
    constructor(public address: Address) {}
}

export class AddPersonFiles {
    readonly type = 'ADD_PERSON_FILES';
    constructor(public files: Files[]) {}
}

export class DisablePersonFile {
    readonly type = 'DISABLE_PERSON_FILES';
    constructor(public file: Files) {}
}
export class DisablePersonFileOnServer {
    readonly type = 'DISABLE_PERSON_FILES_ON_SERVER';
    constructor(public fileUrl: string) {}
}
export class RemovePersonFiles {
    readonly type = 'REMOVE_PERSON_FILES';
    constructor(public index: number) {}
}
export class RemovePersonFilesOnServer {
    readonly type = 'REMOVE_PERSON_FILES_ON_SERVER';
    constructor(public blockReference: string) {}
}

export class AddPersonProfission {
    readonly type = 'ADD_PERSON_PROFISSION';
    constructor(public profission: Profession) {}
}

export class AddPersonBank {
    readonly type = 'ADD_PERSON_BANK';
    constructor(public bankData: BankData[]) {}
}

export class AddPersonContract {
    readonly type = 'ADD_PERSON_CONTRACT';
    constructor(public contractData: ContractData) {}
}

export class AddPersonBeneficiaries {
    readonly type = 'ADD_PERSON_BENEFICIARIES';
    constructor(public beneficiaries: Beneficiary[]) {}
}

export class AddPersonPix {
    readonly type = 'ADD_PERSON_PIX';
    constructor(public pixs: Pix[]) {}
}

export class AddPersonAuthorizations {
    readonly type = 'ADD_PERSON_AUTHORIZATIONS';
    constructor(public authorizations: Authorizations) {}
}

export class AddPersonSuitability {
    readonly type = 'ADD_PERSON_SUITABILITY';
    constructor(public suitability: Suitability) {}
}

export class UpdatePersonPpe {
    readonly type = 'ADD_PERSON_Ppe';
    constructor(public ppe: Ppe) {}
}

export class AddPersonSuitabilityScore {
    readonly type = 'ADD_PERSON_FINANCIAL_COMPATIBILITY';
    constructor(public suitabilityScore: SuitabilityScore) {}
}

export class AddPersonSuitabilityQuestions {
    readonly type = 'ADD_PERSON_SUITABILITY_QUESTIONS';
    constructor(public suitability: Suitability) {}
}

export class UpdatePersonFinancialStatement {
    readonly type = 'UPDATE_PERSON_FINANCIAL_STATEMENT';
    constructor(public financialAssets: FinancialStatement) {}
}

export class UpdatePersonAddressOnServer {
    readonly type = 'UPDATE_PERSON_ADDRESS_ON_SERVER';
    constructor(public address: Address) {}
}

export class UpdatePersonFilesOnServer {
    readonly type = 'UPDATE_PERSON_FILES_ON_SERVER';
    constructor(public files: Files[]) {}
}

export class UpdatePersonProfissionOnServer {
    readonly type = 'UPDATE_PERSON_PROFISSION_ON_SERVER';
    constructor(public profission: Profession) {}
}

export class UpdatePersonBankOnServer {
    readonly type = 'UPDATE_PERSON_BANK_ON_SERVER';
    constructor(public bankData: BankData[]) {}
}

export class UpdatePersonContractOnServer {
    readonly type = 'UPDATE_PERSON_CONTRACT_ON_SERVER';
    constructor(public contractData: ContractData) {}
}

export class UpdatePersonBeneficiariesOnServer {
    readonly type = 'UPDATE_PERSON_BENEFICIARIES_ON_SERVER';
    constructor(public beneficiariesData: Beneficiary[]) {}
}

export class UpdatePersonPixOnServer {
    readonly type = 'UPDATE_PERSON_PIX_ON_SERVER';
    constructor(public pixs: Pix[]) {}
}

export class UpdatePersonAuthorizationsOnServer {
    readonly type = 'UPDATE_PERSON_AUTHORIZATIONS_ON_SERVER';
    constructor(public authorizations: Authorizations) {}
}

export class UpdatePersonSuitabilityOnServer {
    readonly type = 'UPDATE_PERSON_SUITABILITY_ON_SERVER';
    constructor(public suitability: Suitability) {}
}

export class UpdatePersonPpeOnServer {
    readonly type = 'UPDATE_PERSON_PPE_ON_SERVER';
    constructor(public ppe: Ppe) {}
}

export class UpdatePersonSuitabilityScoreOnServer {
    readonly type = 'UPDATE_PERSON_FINANCIAL_COMPATIBILITY_ON_SERVER';
    constructor(public suitabilityScore: SuitabilityScore) {}
}

export class UpdatePersonSuitabilityQuestionsOnServer {
    readonly type = 'UPDATE_PERSON_SUITABILITY_QUESTIONS_ON_SERVER';
    constructor(public suitability: Suitability) {}
}

export class   UpdatePersonFinancialStatementOnServer {
    readonly type = 'UPDATE_PERSON_FINANCIAL_STATEMENT_ON_SERVER';
    constructor(public financialAssets: FinancialStatement) {}
}

export class AddOnlyPersonOnServer {
    readonly type = 'ADD_ONLY_PERSON_ON_SERVER';
    constructor(public person: PersonData, public agentId: string) {}
}

export class AddPersonOnlyState {
    readonly type = 'ADD_ONLY_PERSON_ON_SERVER';
    constructor(public person: PersonData, public agentId: string) {}
}

export class AddPersonSuitabilityFile {
    readonly type = 'ADD_PERSON_SUITABILITY_FILE';
    constructor(public socialNumber: string, public virtualRawFingerprint: string) {}
}


export class AddPersonPaymentAccountOpeningFile {
    readonly type = 'ADD_PERSON_PAYMENT_ACCOUNT_OPENING_FILE';
    constructor(public socialNumber: string, public virtualRawFingerprint: string) {}
}

export type Actions =
    | AddPerson
    | AddPersonAddress
    | AddPersonProfission
    | AddPersonBank
    | AddPersonAuthorizations
    | AddPersonOnServer
    | AddPersonRegistrationHistory
    | UpdatePersonFilesOnServer
    | UpdatePersonAddressOnServer
    | UpdatePersonProfissionOnServer
    | UpdatePersonBankOnServer
    | UpdatePersonContractOnServer
    | UpdatePersonBeneficiariesOnServer
    | UpdatePersonAuthorizationsOnServer
    | AddPersonSuitabilityQuestions
    | UpdatePersonPpeOnServer
    | UpdatePersonSuitabilityQuestionsOnServer
    | RemovePersonFiles
    | RemovePersonFilesOnServer
    | DisablePersonFile
    | DisablePersonFileOnServer
    | CleanPerson
    | UpdatePersonFinancialStatement
    | UpdatePersonFinancialStatementOnServer
    | AddPersonSuitability
    | AddOnlyPersonOnServer
    | AddPersonOnlyState
    | AddPersonSuitabilityFile
    | AddPersonPaymentAccountOpeningFile;
